import { Molecule, wrap } from 'AppReact';
import styled, { css } from 'styled-components';
import { SecondaryTextSm, SecondaryTextSm400, Icon } from 'atoms';
import { Mr2 } from 'wrappers';

const template = styled.div`
  ${({ displayState }) => css`
    display: flex;
    align-items: center;
    white-space: ${displayState?.wrap ? '' : 'nowrap'};
  `}
`;

export default Molecule({
  template,
  atoms: [
    {
      component: wrap(Icon, Mr2),
      name: 'Icon',
      displayValue: ({ icon }) => icon
    },
    {
      component: wrap(SecondaryTextSm400, Mr2),
      name: 'Key',
      displayValue: ({ label }) => label,
      displayState: ({ color }) => ({ color: color }),
    },
    {
      component: SecondaryTextSm,
      name: 'Value',
      displayValue: ({ value }) => value,
      displayState: ({ color }) => ({ color: color }),
    },
  ]
})